<!-- 我的 -->
<template>
  <div class="mine-page">
    <div class="m-body">
      <template v-if="data.id">
        <div class="top">
          <img class="photo" :src="data.photo.url" />
          <div class="info">
            <div class="name">{{ data.name }}</div>
            <div class="tips">{{ data.phoneHidden }}</div>
          </div>
        </div>

        <div class="list">
          <div class="title" v-if="data.studentVoList.length > 0">学员信息</div>
          <div class="stu" v-for="item in data.studentVoList" :key="item.id">
            <div class="photowrap">
              <div
                v-if="judge(item)"
                class="phot"
                :style="`backgroundImage: url(${item.studentFaceList[0].faceUrl});`"
              ></div>
              <div v-else class="phtxt">{{ item.name.substr(-2) }}</div>
            </div>
            <div class="mid">
              <div class="m1">
                {{ item.name }}<span class="compy van-ellipsis">{{ item.companyName }}</span>
              </div>
              <div class="m2">
                <template v-if="judge(item)"
                  ><van-icon name="checked" size="16" color="var(--c2)" />可接收到校通知</template
                >
                <template v-else
                  ><van-icon name="warning" size="16" color="#F00" />请完成人脸信息采集</template
                >
              </div>
            </div>
            <template>
              <van-button square round size="small" @click="goCollect(item)" v-if="judge(item)"
                >重新采集</van-button
              >
              <van-button square round type="primary" size="small" @click="goCollect(item)" v-else
                >采集人脸</van-button
              >
            </template>
          </div>
        </div>
      </template>
    </div>

    <div class="m-foot" v-if="isFaceApp">
      <div class="btn" @click="logout">退出登录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'face-mine',
  data() {
    return {
      pageTitle: '我的',
      data: {},
      isFaceApp: app.parent.app_type == 'face',
    };
  },
  methods: {
    goCollect(stu) {
      this.$router.push(`/face/collect/${stu.id}/${stu.companyId}`);
    },
    async render() {
      let api = '',
        params = {};
      if (this.isFaceApp) {
        api = this.$api.getParentsInfo;
      } else {
        api = this.$api.getParentsInfoByCompany;
        params = {
          companyId: app.tool.parseQuery().companyId,
        };
      }
      let ret = await api(params);
      this.data = ret.data;
    },
    // 判断是否已采集人脸
    judge(student) {
      return student.studentFaceList && student.studentFaceList.length > 0;
    },
    logout() {
      vant.Dialog.alert({
        message: '退出登录后无法收到孩子到校通知，是否确认退出？',
        confirmButtonText: '退出',
        showCancelButton: true,
        confirmButtonColor: 'var(--c3)',
      })
        .then(async () => {
          await this.$api.userLogout();
          app.ls.remove('x3-parent-token');
          app.parent.loginFace();
        })
        .catch(err => {
          console.log('不退出了');
        });
    },
  },
  created() {
    this.render();
    this.$onBus('face-collect-success', () => {
      this.render();
    });
  },
};
</script>

<style lang="scss" scoped>
.mine-page {
  display: flex;
  flex-direction: column;
  .m-body {
    padding: 16px;
    flex: 1;
    overflow: auto;
    .top {
      padding: 16px;
      background-color: var(--white);
      border-radius: 8px;
      position: relative;
      display: flex;
      align-items: center;
      .photo {
        width: 44px;
        height: 44px;
        margin-right: 8px;
        border-radius: 100%;
      }
      .info {
        position: relative;
        flex: 1;
        .name {
          line-height: 1;
          font-size: 16px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          color: var(--g8);
        }
        .tips {
          margin-top: 4px;
          color: var(--g6);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
        }
      }
    }
    .list {
      .title {
        padding: 20px 0 16px 0;
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--g8);
      }
      .stu {
        margin-bottom: 16px;
        padding: 16px;
        background-color: var(--white);
        border-radius: 8px;
        display: flex;
        align-items: center;
        .photowrap {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background-color: #1952e1;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .phot {
            width: 100%;
            height: 100%;
            background-image: url();
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-attachment: scroll;
          }
          .phtxt {
            color: var(--white);
            text-align: center;
          }
        }
        .mid {
          flex: 1;
          .m1 {
            line-height: 1;
            font-size: 16px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .compy {
              margin-left: 8px;
              padding: 3px 8px;
              display: inline-block;
              font-size: var(--fs-xs);
              color: var(--g6);
              background-color: var(--g2);
              border-top-left-radius: 100px;
              border-top-right-radius: 100px;
              border-bottom-left-radius: 2px;
              border-bottom-right-radius: 100px;
              max-width: 100px;
            }
          }
          .m2 {
            margin-top: 6px;
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
            color: var(--g6);
            display: flex;
            align-items: center;
            .van-icon {
              margin-right: 2px;
            }
          }
        }
      }
    }
  }
  .m-foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      padding: 10px;
      font-weight: 400;
      color: #969799;
    }
  }
}
</style>